
import environment from "../../../../../environments/environment";
import { axiosInterceptor } from "../../authInterceptor";

const TASK_SUMMARY_URL = environment.getTaskSummaryListURL;
const TASK_DETAILS_BY_ID_URL = environment.getVendorInvoiceTaskByIdURL;

//workflow/actions/invoice/34/status-code/1000?clientId=1
export async function getVendorInvoiceActionsById(invoiceId: number, statusCode: string, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.getVendorInvoiceActionsById}${invoiceId}/status-code/${statusCode}?clientId=${clientId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;

  } catch (error) {
    console.error('There was an error to get the Invoice actions detsild by Invoice Id !', error);
    throw error;
  }
}
export async function postVendorInvoicePaymentAllocation(paymentallocation: any) {

  try {
    const response = await axiosInterceptor.post(environment.postPaymentAllocationURL, paymentallocation);
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export async function getVendorInvoiceTaskById(id: number, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${TASK_DETAILS_BY_ID_URL}${id}?clientId=${clientId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;

  } catch (error) {
    console.error('There was an error to get the Invoice Tasks detsild by TaskId !', error);
    throw error;
  }
}


//{{base_url}}invoice/3549/notify-business-manager?clientId=1

export async function postNotiFyBuusinessManager(invoiceId: number, clientId: number) {
  try {
    const response = await axiosInterceptor.post(`${environment.postNotifyBusinessManager}${invoiceId}/notify-business-manager?clientId=${clientId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;

  } catch (error) {
    console.error('There was an error post the Business Manager !', error);
    throw error;
  }
}

export async function getInvoiceTasksSummary(filter: any) {
  try {
    const response = await axiosInterceptor.post(`${TASK_SUMMARY_URL}`, filter, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;

  } catch (error) {
    console.error('There was an error to get the Invoice Tasks Summary !', error);
    throw error;
  }
}

